<template>
  <div>
    <b-modal
      id="modal-edit"
      size="lg"
      centered
      title="Tambah Data Tunjangan Tidak Tetap"
      header-bg-variant="primary"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group label=" Nama Tunjangan" label-cols-md="3">
          <b-form-input
            :state="checkIfValid('namaTunjangan')"
            v-model="$v.data.namaTunjangan.$model"
            @keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
      </b-form>

      <b-form>
        <b-form-group label="Nominal Tunjangan" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('nominalTunjangan')"
            v-model="$v.data.nominalTunjangan.$model"
            :placeholder="convert(data.nominalTunjangan)"
            @keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <b-form>
        <b-form-group label="Maksimal Tunjangan" label-cols-md="3">
          <b-form-input
            :state="checkIfValid('maksimalTunjangan')"
            v-model="$v.data.maksimalTunjangan.$model"
            :placeholder="convert(data.maksimalTunjangan)"
            @keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-edit')"
        >
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="primary" @click="simpan()" :disabled="!isValid"
          >Simpan</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  name: "modalInput",
  props: ["data"],
  data() {
    return {
      selected: null,
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      namaTunjangan: {
        required,
      },
      nominalTunjangan: {
        required,
        numeric,
      },
      maksimalTunjangan: {
        required,
      },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    convert(x) {
      if (x) {
        return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    simpan() {
      let vm = this;
      if (vm.isValid) {
        vm.busy = true;
        vm.button = "Mohon Tunggu";
        vm.$axios
          .post("masterTunjanganTidakTetap/update", vm.data)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$v.$reset();
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENDAFTARKAN MASTER TUNJANGAN TIDAK TETAP",
                showing: true,
              });
              this.$bvModal.hide("modal-edit");
              this.reset();
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            err;
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: "TERJADI KESALAHAN PADA SERVER",
              showing: true,
            });
          });
      }
    },
    reset() {
      this.$v.$reset();
      // this.data = {
      //   namaTunjangan: "",
      //   nominalTunjangan: "",
      // };
    },
  },
};
</script>
